// A saved attempt is immutable: uncertain responses always retry the same payload.
export function newAttempt(query, token, snapshot, cryptoApi = window.crypto) {
  const bytes = new Uint8Array(16)
  cryptoApi.getRandomValues(bytes)
  return {
    payload: { ...query, quote_token: token, request_id: Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('') },
    snapshot
  }
}

export function attemptKey(account, goodsId, quantity) {
  return `limited-order:${encodeURIComponent(account)}:${goodsId}:${quantity}`
}

export function decorateActivityTitles(datas, enabled) {
  if (!enabled || !datas || typeof datas !== 'object') return
  const goods = [...(Array.isArray(datas.goods_list) ? datas.goods_list : []), datas.goods_info]
  goods.forEach(item => {
    if (!item || !item.limited_stock_id || !item.limited_activity_name || !item.goods_name) return
    const prefix = `【${item.limited_activity_name}】`
    if (!item.goods_name.startsWith(prefix)) item.goods_name = prefix + item.goods_name
  })
}

// These responses occur before a new order commits. Unknown errors must retain the attempt.
export function needsNewQuote(error) {
  return ['请刷新页面并确认订单价格', '报价已失效，请重新确认', '价格或活动已变化，请重新确认', '活动库存不足', '活动余量不足，请减少购买数量', '活动还没有开始'].includes(error)
}

// Activity-only restriction; ordinary product stock and purchase limits still apply.
export function detailActivity(goods, enabled) {
  return enabled && goods && goods.limited_activity ? goods.limited_activity : null
}

export function activityBlocksPurchase(goods, enabled) {
  if (!enabled || !goods) return false
  const activity = detailActivity(goods, enabled)
  return !!(goods.limited_preheat || (activity && activity.can_buy === false))
}

export function activityTime(timestamp) {
  if (!Number.isFinite(Number(timestamp)) || Number(timestamp) <= 0) return ''
  const date = new Date(Number(timestamp) * 1000 + 8 * 3600000)
  const pad = value => String(value).padStart(2, '0')
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
}

export function activityListSummary(goods, enabled) {
  const activity = detailActivity(goods, enabled)
  if (!activity) return null
  if (activityBlocksPurchase(goods, enabled)) return { name: activity.name, status: '活动未开始', mode: 'blocked' }
  if (activity.state === 'upcoming') return { name: activity.name, status: '未开始 · 可原价购买', mode: 'normal' }
  if (activity.state === 'active') return { name: activity.name, status: '活动进行中', mode: 'activity' }
  if (activity.state === 'sold_out') return { name: activity.name, status: '名额已售罄 · 原价购买', mode: 'normal' }
  return null
}
